/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatchReadyReportResponse
 */
export interface MatchReadyReportResponse {
    /**
     * 
     * @type {string}
     * @memberof MatchReadyReportResponse
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof MatchReadyReportResponse
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof MatchReadyReportResponse
     */
    matchKey: string;
    /**
     * 
     * @type {number}
     * @memberof MatchReadyReportResponse
     */
    reportedAt: number;
}

/**
 * Check if a given object implements the MatchReadyReportResponse interface.
 */
export function instanceOfMatchReadyReportResponse(value: object): value is MatchReadyReportResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('teamId' in value) || value['teamId'] === undefined) return false;
    if (!('matchKey' in value) || value['matchKey'] === undefined) return false;
    if (!('reportedAt' in value) || value['reportedAt'] === undefined) return false;
    return true;
}

export function MatchReadyReportResponseFromJSON(json: any): MatchReadyReportResponse {
    return MatchReadyReportResponseFromJSONTyped(json, false);
}

export function MatchReadyReportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchReadyReportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'teamId': json['teamId'],
        'matchKey': json['matchKey'],
        'reportedAt': json['reportedAt'],
    };
}

export function MatchReadyReportResponseToJSON(json: any): MatchReadyReportResponse {
    return MatchReadyReportResponseToJSONTyped(json, false);
}

export function MatchReadyReportResponseToJSONTyped(value?: MatchReadyReportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'teamId': value['teamId'],
        'matchKey': value['matchKey'],
        'reportedAt': value['reportedAt'],
    };
}

